import * as React from 'react';
import isEmpty from 'lodash/isEmpty';

import CcmCampaignsTableByState from '../../campaigns-table/ccm/CcmCampaignsTableByState';

import { __t, applyTranslations } from 'utils/language';

import './campaigns-dashboard-ccm.scss';

applyTranslations(require('./campaigns-dashboard-ccm.i18n.json'));

import type {
  Campaign,
  Pagination
} from 'types';

type Props = {
  campaigns: Array<Campaign>,
  campaignsPagination: Pagination,
  campaignsIsLoading: boolean,
  campaignState: string,
  isMixedCampaigns: boolean,
  hasFilters: boolean,
  onPageChange: (page: number) => void
};

const MSG_KEY = 'campaigns_dashboard_ccm';
const containerRef = React.createRef<HTMLDivElement>();

const CampaignsDashboardCcm: React.FC<Props> = ({
  campaigns,
  campaignsPagination,
  campaignsIsLoading,
  campaignState,
  isMixedCampaigns,
  hasFilters,
  onPageChange
}): JSX.Element => {
  const handlePageChange = (
    page: number
  ): void => {
    onPageChange(page);

    if (containerRef.current) {
      containerRef.current.scrollIntoView({
        block: 'center', behavior: 'smooth'
      });
    }
  };

  const renderEmpty = (): React.ReactNode => (
    <div className="campaigns-dashboard-ccm__empty">
      {__t(`${MSG_KEY}.messages.empty_${hasFilters ? 'search' : campaignState}`)}
    </div>
  );

  const renderCampaignsTable = (): React.ReactNode => (
    <CcmCampaignsTableByState
      campaignsIsLoading={campaignsIsLoading}
      campaignsList={campaigns}
      campaignsPagination={campaignsPagination}
      onPageChange={handlePageChange}
    />
  );

  const renderCampaigns = (): React.ReactNode => (
    !campaignsIsLoading && isEmpty(campaigns)
      ? renderEmpty()
      : renderCampaignsTable()
  );

  return (
    <div
      ref={containerRef}
      className="campaigns-dashboard-ccm"
    >
      {
        isMixedCampaigns && (
          <div className="campaigns-dashboard-ccm__title">
            {__t(`${MSG_KEY}.title`)}
          </div>
        )
      }
      <div className="campaigns-dashboard-ccm__campaigns">
        {renderCampaigns()}
      </div>
    </div>
  );
};

export default CampaignsDashboardCcm;
